var render = function render(){var _vm=this,_c=_vm._self._c;return _c('duo-agents-platform-index',{attrs:{"has-initial-workflows":_vm.hasInitialWorkflows,"initial-sort":_vm.currentSort,"is-loading-workflows":_vm.isLoadingWorkflows,"workflows":_vm.workflows,"workflows-page-info":_vm.workflowsPageInfo},on:{"query-variables-updated":_vm.handleQueryVariablesUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }